// Dev base URL
// export const API_BASE_URL =
//   "https://ppprofit.5stardesigners.net:3001/dev/play_pound_profit/api/v1";

export const API_BASE_URL =
  // "https://api.playpoundprofit.co.uk:3001/dev/play_pound_profit/api/v1";
  "https://api.playpoundprofit.co.uk:3002/dev/play_pound_profit/api/v1";
  // "https://ppprofit.5stardesigners.net:3001/dev/play_pound_profit/api/v1"
// "homepage": "https://admin.playpoundprofit.co.uk/",

export const CHANGEPASSWORD_ENDPOINT = "/update-password";

// ----------------------- PPP --------------------------------

//AUTH ENDPOINTS
export const LOGIN_ENDPOINT = "/auth/login";
export const FORGETPASSWORD_ENDPOINT = "/auth/forget-password";
export const VERIFYCODE_ENDPOINT = "/auth/verify-token";
export const RESETPASSWORD_ENDPOINT = "/auth/reset-password";
export const LOGOUT_ENDPOINT = "/user/logout";
export const GAMES_ENDPOINT = "/admin/games";
export const WINNER_ENDPOINT = "/admin/winners";
export const WINNER_UPDATE_ENDPOINT = "/admin/winner";
export const GETGAMES_ENDPOINT = "/game";
export const SENDNOTIFICATION_ENDPOINT = "/admin/send-notification";
export const GETUSERS_ENDPOINT = "/admin/users";
export const USERSTATUSUPDATE_ENDPOINT = "/admin/users";
export const USER_STATS_ENDPOINT = "/admin/user-stats";
export const FREEPAID_GAMES = "/admin/free-paid-game-stats";
export const TOTALGAMES = "/admin/total-game-stats";
export const SIGNUPSTATS = "/admin/signup-stats";
export const MESSAGES_ENDPOINT = "/admin/messages";
export const TRANSACTION_ENDPOINT = "/admin/transactions";
export const PAY_IN_DETAILS_ENDPOINT = "/admin/transactions/payin";
export const PAY_OUT_DETAILS_ENDPOINT = "/admin/transactions/payout";
export const GET_PRIZEPOOL_ENDPOINT = "/admin/games/prize-pool";
export const GET_PRIZEPOOL_DETAILS_ENDPOINT = "/admin/games/";
export const GET_CURRENT_OR_PREVIOUS_USERS = "/admin/games/";
export const GET_LUCKYDRAW_CONFIG_ENDPOINT = "/admin/luckydraw";
export const UPDATE_LUCKYDRAW_CONFIG_ENDPOINT = "/admin/luckydraw/";
export const GET_LUCKYDRAW_POOL_ENDPOINT = "/admin/luckydraw/pool";
export const GET_LUCKYDRAW_POOL_DETAILS_ENDPOINT = "/admin/luckydraw/pool/";
export const GET_LUCKYDRAW_WINNERS_ENDPOINT = "/admin/luckydraw/winners";
export const UPDATE_LUCKYDRAW_WINNERS_ENDPOINT = "/admin/luckydraw/payment-status/";

// Rewards Management
export const REWARDS_SETTINGS_ENDPOINT = "/admin/settings";
export const REWARDS_SETTINGS_TOGGLE_ENDPOINT = "/admin/settings/toggle";
export const REWARDS_SETTINGS_CONFIG_ENDPOINT = "/admin/settings/config";
export const REWARDS_REFERRAL_CONFIG_ENDPOINT = "/admin/settings/referral-config";
export const REWARDS_FIRST_PURCHASE_CONFIG_ENDPOINT = "/admin/settings/first-purchase-config";
export const DAILY_REWARDS_ENDPOINT = "/admin/daily-rewards";
export const FREE_PLAY_CONFIG_ENDPOINT = "/admin/game/free-play-config";



const configVariables = {
  // appUrl,
  // appUrlForReview,
  //baseUrl: `${baseUrl}`,
  termsUrl: "",
  privacyUrl: "",
  contactSupportMail: "",
  //instructionsUrl: `${baseUrl}`,
};

const constantVariables = {
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  messageForAppShare: "",
  subjectForAppShare: "",
};

export default {
  ...configVariables,
  ...constantVariables,
};
